/**
 * The panel's single HTTP client. Every API call goes through this instance with a relative path
 * ('/api/admin/...'): base URL, auth token and 401 handling live here only.
 */
import axios from 'axios'
import { REQUEST_BASE } from './config'
import { getSiteId, setSiteId, DEFAULT_SITE_ID } from '@/utils/site'

const http = axios.create({ baseURL: REQUEST_BASE })

const PUBLIC_PATHS = /\/api\/admin\/user\/(login|validate-token)\b|\/api\/market\//

export function getToken() {
  try { return localStorage.getItem('token') || '' } catch (e) { return '' }
}

http.interceptors.request.use((config) => {
  const token = getToken()
  const headers = config.headers || (config.headers = {})
  const hasAuth = Object.keys(headers).some((k) => k.toLowerCase() === 'authorization' && headers[k])
  if (token && !hasAuth && !PUBLIC_PATHS.test(config.url || '')) headers.Authorization = 'Bearer ' + token
  // multi-site: every call targets the site chosen in the header switcher
  if (!Object.keys(headers).some((k) => k.toLowerCase() === 'x-site-id')) headers['X-Site-Id'] = getSiteId()
  return config
})

let redirecting = false
http.interceptors.response.use((res) => res, (error) => {
  const status = error && error.response && error.response.status
  const url = (error && error.config && error.config.url) || ''
  // selected site unknown / not configured / not allowed for this admin -> back to the default site
  const data = (error && error.response && error.response.data) || {}
  if ((status === 503 && data.site) || (status === 400 && data.msg === 'سایت نامعتبر است') || (status === 403 && data.msg === 'به این سایت دسترسی ندارید')) {
    if (getSiteId() !== DEFAULT_SITE_ID) { setSiteId(DEFAULT_SITE_ID); window.location.reload() }
  }
  if (status === 401 && !PUBLIC_PATHS.test(url) && !redirecting) {
    redirecting = true
    try { localStorage.removeItem('token') } catch (e) { /* ignore */ }
    const here = window.location.pathname + window.location.search
    if (!/\/login\b/.test(window.location.pathname)) {
      window.location.assign('/dashboard/login?redirect=' + encodeURIComponent(here))
    }
    setTimeout(() => { redirecting = false }, 3000)
  }
  return Promise.reject(error)
})

export default http
